export default __webpack_public_path__ + "static/media/inspiration.4053a387.jpg";